/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {SpecialOrderPositionValidationResultModel} from '../../../api/ms-specialorders/contracts/special-order-position-validation-result.model';
import * as XLSX from 'xlsx';

type WorksheetData = any[][];

@Component({
    selector: 'app-excel-download',
    templateUrl: './excel-download.component.html',
    styleUrls: ['./excel-download.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExcelDownloadComponent {
    @Input() invalidMaterials: SpecialOrderPositionValidationResultModel[] = [];
    private readonly fileName: string = 'orcan-excel-upload.xlsx';
    private readonly worksheetHeader = [
        'Material',
        'Model type',
        'LOT number',
        'MCDR number',
        'Quantity'
    ];

    constructor() {
    }

    mapWorksheetData(): WorksheetData {
        const worksheetData = this.invalidMaterials.map(material => [
            material.material.original,
            material.modelType.original,
            material.lotNumber.original,
            material.mcdrNumber.original,
            material.orderQuantity.original
        ]);

        const worksheet = [this.worksheetHeader].concat(worksheetData);

        return worksheet;
    }

    export(): void {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(this.mapWorksheetData(), {skipHeader: true});
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Materials');

        XLSX.writeFile(workbook, this.fileName);
    }
}
